import { Button, Flex, Table, TableColumnsType } from "antd";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

export type StopFreeSaleExportTableProps = {
  dataSource?: mdlStopFreeSaleDetail[],
  fnAgencyMailPreview?: Function;
}

export const StopFreeSaleExportTable = (props: StopFreeSaleExportTableProps) => {
  const { t } = useTranslation();

  const fnAgencyMailPreview = (e: any) => {
    props.fnAgencyMailPreview && props.fnAgencyMailPreview(e);
  }

  const baseColumns: TableColumnsType<mdlStopFreeSaleDetail> = [
    {
      title: t("stopFreeSaleExportTable.agencyName"),
      dataIndex: 'agencyName',
      key: 'agencyName'
    },
    {
      title: t("stopFreeSaleExportTable.market"),
      dataIndex: 'marketName',
      key: 'marketName'
    },
    {
      title: t("stopFreeSaleExportTable.room"),
      dataIndex: 'roomName',
      key: 'roomName'
    },
    {
      title: t("stopFreeSaleExportTable.roomType"),
      dataIndex: 'roomTypeName',
      key: 'roomTypeName'
    },
    {
      title: t("stopFreeSaleExportTable.board"),
      dataIndex: 'boardName',
      key: 'boardName'
    },
    {
      title: t("stopFreeSaleExportTable.actions"),
      key: 'actions',
      hidden: !props.fnAgencyMailPreview,
      render: (e: mdlStopFreeSaleDetail) => {
        return !props.fnAgencyMailPreview ? <></> : <>
          <Flex gap="small" wrap >
            <Button
              onClick={() => fnAgencyMailPreview(e)}
              className="btn btn-sm btn-primary"
              size="middle"
            >
              <FontAwesomeIcon icon={faPencil} />
              {t('stopFreeSale.create.mailPreview')}
            </Button>
          </Flex>
        </>
      }
    }
  ];


  const getScreenSize = () => {
    return `${(window.screen.height * 65) / 100}px`;
  }

  return (
    <Flex gap="middle" align="start" vertical>
      <Table<mdlStopFreeSaleDetail>
        style={{ maxHeight: getScreenSize(), width: "100%" }}
        columns={baseColumns}
        pagination={false}
        size="small"
        dataSource={props.dataSource}
      />
    </Flex >
  );
};
